// extracted by mini-css-extract-plugin
module.exports = {"icon":"ValidationStatusField_icon__1s0Hm"};